"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateTimePicker = DateTimePicker;

var _react = _interopRequireWildcard(require("react"));

var _DateTimePicker = _interopRequireDefault(require("react-widgets/lib/DateTimePicker"));

var _reactWidgetsMoment = _interopRequireDefault(require("react-widgets-moment"));

var _moment = _interopRequireDefault(require("moment"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _brockDateTime = require("brock-date-time");

var _Field = require("./Field");

var _excluded = ["cssClassModifiers", "label", "isValid", "errorMessage"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

(0, _reactWidgetsMoment["default"])(_moment["default"]); // eslint-disable-next-line complexity

function getFormat(format, isTime, isDate) {
  if (format) {
    return format;
  }

  if (isTime && isDate) {
    return _brockDateTime.DateTimeFormats.DATETIME;
  }

  return isDate ? _brockDateTime.DateTimeFormats.DATE : _brockDateTime.DateTimeFormats.TIME;
}

function parseDate(date, format) {
  if (!date) {
    return null;
  }

  var momentDate = (0, _moment["default"])(date, format);
  return momentDate.isValid() ? momentDate.toDate() : null;
} // eslint-disable-next-line complexity


function getPickerTypeClassModifier(hasDate, hasTime) {
  if (hasDate && hasTime) {
    return 'date-time-picker';
  }

  if (hasDate) {
    return 'date-picker';
  }

  return 'time-picker';
}

function DateTimePicker(props) {
  var datePickerRef = (0, _react.useRef)();

  var cssClassModifiers = props.cssClassModifiers,
      label = props.label,
      isValid = props.isValid,
      errorMessage = props.errorMessage,
      remainingProps = _objectWithoutProperties(props, _excluded);

  var dateFormat = getFormat(props.formatString, props.time, props.date);
  var errorClass = props.isValid ? '' : 'rw-widget-container--error';
  (0, _react.useEffect)(function () {
    var datePicker = datePickerRef.current.querySelector('.rw-widget-input');

    if (datePicker) {
      datePicker.setAttribute('size', 1);
    }
  }, []);
  return (
    /*#__PURE__*/
    _react["default"].createElement(_Field.Field, {
      cssClassModifiers: [].concat(_toConsumableArray(cssClassModifiers), [getPickerTypeClassModifier(props.date, props.time)]),
      label: label,
      isValid: isValid,
      errorMessage: errorMessage,
      disabled: remainingProps.disabled
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      ref: datePickerRef
    },
    /*#__PURE__*/
    _react["default"].createElement(_DateTimePicker["default"], _extends({}, remainingProps, {
      format: dateFormat,
      timeFormat: _brockDateTime.DateTimeFormats.TIME,
      parse: function parse(date) {
        return parseDate(date, dateFormat);
      },
      containerClassName: errorClass
    }))))
  );
}

DateTimePicker.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  cssClassModifiers: _propTypes["default"].arrayOf(_propTypes["default"].string),
  culture: _propTypes["default"].string,
  date: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  errorMessage: _propTypes["default"].string,
  formatString: _propTypes["default"].string,
  isValid: _propTypes["default"].bool,
  label: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  time: _propTypes["default"].bool
};
DateTimePicker.defaultProps = {
  cssClassModifiers: [],
  culture: 'en',
  date: true,
  disabled: false,
  errorMessage: '',
  formatString: null,
  isValid: true,
  label: null,
  time: true
};